import { render } from "./ConfirmContractorInvitationModal.vue?vue&type=template&id=4699e874&ts=true"
import script from "./ConfirmContractorInvitationModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmContractorInvitationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__